import React, { Component } from 'react';
import { clearToken } from '../utils';

export default class Logout extends Component {
  componentDidMount() {
    clearToken();
    this.props.history.push('/login');
  }
  render() {
    return <div>Logout</div>;
  }
}



// WEBPACK FOOTER //
// ./src/views/logout.js